<div class="toka-container">
    <div class="toka-box">
        <img src="assets/img/logo.svg" alt="Griky" class="toka-logo" />

        <ng-container *ngIf="status === 'loading'">
            <div class="toka-spinner"></div>
            <p class="toka-message">Iniciando sesión con Toka...</p>
        </ng-container>

        <ng-container *ngIf="status === 'error'">
            <div class="toka-error-icon">✕</div>
            <p class="toka-message toka-message--error">{{ errorMessage }}</p>
        </ng-container>
    </div>
</div>
